import { User } from "./User";
import { RegistrationStatus, parseRegistrationStatus } from './RegistrationStatus';

export class Customer {
  id: number;
  userDetails?: User;
  customersBelow?: Customer[];
  // Backward compatibility + backend alignment
  customerReflexId: number; // legacy
  reflexCustomerNo?: number; // backend current name
  coinsTotal: number;
  coinsCurrent: number;
  isActive: boolean;
  isParent?: boolean; // Can manage child accounts
  registrationStatus?: RegistrationStatus;
  azureObjectId?: string;
  accountState?: string; // Registered, Enabled, Deactivated, Deleted
  companyShortName?: string;

  constructor(init: Partial<Customer>) {
    this.id = init.id ?? 0;
    this.userDetails = init.userDetails;
    this.customersBelow = init.customersBelow;
    this.customerReflexId = init.customerReflexId ?? 0;
    this.reflexCustomerNo = (init as any).reflexCustomerNo ?? this.customerReflexId;
    this.coinsTotal = init.coinsTotal ?? 0;
    this.coinsCurrent = init.coinsCurrent ?? 0;
    this.isActive = init.isActive ?? false;
    this.isParent = (init as any).isParent ?? false;
    this.registrationStatus = parseRegistrationStatus((init as any).registrationStatus);
    this.azureObjectId = (init as any).azureObjectId;
    this.accountState = (init as any).accountState ?? 'Registered';
    this.companyShortName = (init as any).companyShortName;
  }
}
